import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/content";
import { BookButton } from "./BookButton";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/membership", label: "Membership" },
  { to: "/contact", label: "Request Service" },
  { to: "/pay", label: "Pay Online" },
  { to: "/portal", label: "Portal" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo-icon.png" alt="Mason's Mobile Mechanic logo" className="h-14 md:h-[4.25rem] w-auto" />
          <div className="leading-none hidden sm:block">
            <span className="font-heading font-bold text-white text-lg tracking-tight block">MASON'S</span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">Mobile Mechanic</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-medium transition-colors ${
                pathname === l.to ? "text-blue-400" : "text-zinc-300 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <BookButton className="!py-2 !px-4" />
          <a
            data-testid="nav-call-button"
            href={PHONE_TEL}
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-zinc-800 px-6 py-6 space-y-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setOpen(false)}
              className="block text-zinc-200 font-medium text-lg"
            >
              {l.label}
            </Link>
          ))}
          <BookButton className="w-full justify-center" />
          <a
            data-testid="mobile-nav-call-button"
            href={PHONE_TEL}
            className="flex items-center justify-center gap-2 bg-blue-600 text-white rounded-sm px-5 py-3 font-semibold"
          >
            <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
          </a>
        </div>
      )}
    </header>
  );
};
